import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  return (
    <a
      href="https://wa.me/919320201572?text=Hi%20CyberCart%2C%20I%27d%20like%20to%20discuss%20a%20project"
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-2 px-4 py-3 rounded-full shadow-lg text-white font-medium hover:translate-y-[-2px] transition-transform"
      style={{ background: "#1FA855" }}
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">WhatsApp us</span>
    </a>
  );
}
